import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getFilterSelector } from 'common/components/AssetBrowser/selectors/checkboxFiltersSelector';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { FilterLookup, FilterType } from '../FilterLookup';
import { APPROVALS } from 'common/core/approvals_enums';
import { ForgeCheckbox } from '@tylertech/forge-react/dist/components/component-wrappers';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

export const CheckboxFilter = ({ filterName }: { filterName: Filters }) => {
  const dispatch: ThunkDispatch<any, unknown, AnyAction> = useDispatch();

  const checkedState = useSelector(getFilterSelector(filterName));
  const getIsChecked = () => {
    // Approval status is a special case since its state is stored as a string value.
    if (filterName === Filters.ApprovalStatus) {
      return checkedState === APPROVALS.STATUS.PENDING;
    } else {
      return checkedState;
    }
  };

  const filterConfig = FilterLookup[filterName];

  // Type guard to ensure this is a Checkbox filter
  if (!filterConfig || filterConfig.filterType !== FilterType.Checkbox) {
    return null;
  }

  // Now TypeScript knows this is a CheckboxEntry
  const { inputId, label, dispatchAction } = filterConfig;

  const onChange = (): void => {
    dispatch(dispatchAction());
  };

  return (
    <ForgeCheckbox
      id={inputId}
      onChange={onChange}
      checked={getIsChecked()}
      data-testid={`checkbox-${inputId}`}
    >
      {label}
    </ForgeCheckbox>
  );
};
